import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/earlyWarning';
const earlyWarning: Array<RouteConfig> = [
    {
        path: 'basic-info/early-warning',
        name: 'early-warning',
        meta: {
            menuMatch: 'earlyWarning',
            index:'7'
        },
        component: () => import(`@/${BASE_PATH}/index.vue`),
    },
];
export default earlyWarning;